// Newsletter-Teaser (Detailseiten) -> Newsletter-Anmeldeseite mit HubSpot-Formular.
// Die Eingaben werden in der sessionStorage uebergeben (nicht in der URL) und befuellen das
// HubSpot-Formular, sobald es geladen ist.
const STORAGE_KEY = 'dgNewsletterPrefill'

function initTeaserForms() {
    document.querySelectorAll('.newsletter-teaser-form').forEach((formElement) => {
        formElement.addEventListener('submit', (event) => {
            const emailElement = formElement.querySelector('[name="email"]')
            const consentElement = formElement.querySelector('[name="newsletterConsent"]')

            try {
                sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
                    email: emailElement ? emailElement.value.trim() : '',
                    consent: consentElement ? consentElement.checked : false,
                }))
            } catch (e) {
                // ohne sessionStorage normal per GET absenden, HubSpot befuellt "email" dann aus der URL
                return
            }

            event.preventDefault()
            window.location.href = formElement.action
        })
    })
}

function readPrefill() {
    try {
        return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null')
    } catch (e) {
        return null
    }
}

// HubSpot-Formulare reagieren nur auf Eingaben, die wie Benutzereingaben ausgeloest werden
function setInputValue(inputElement, value) {
    const valueSetter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set
    valueSetter.call(inputElement, value)
    inputElement.dispatchEvent(new Event('input', { bubbles: true }))
    inputElement.dispatchEvent(new Event('change', { bubbles: true }))
}

function fillHubspotForm(prefill) {
    const formElement = document.querySelector('.hbspt-form form')
    if (!formElement) {
        return false
    }

    const emailElement = formElement.querySelector('input[name="email"], input[type="email"]')
    if (emailElement && prefill.email) {
        setInputValue(emailElement, prefill.email)
    }

    const consentElement = formElement.querySelector('.legal-consent-container input[type="checkbox"]')
        || formElement.querySelector('input[type="checkbox"]')
    if (consentElement && prefill.consent && !consentElement.checked) {
        consentElement.click()
    }

    sessionStorage.removeItem(STORAGE_KEY)
    return true
}

function initHubspotPrefill() {
    const prefill = readPrefill()
    if (!prefill) {
        return
    }

    if (fillHubspotForm(prefill)) {
        return
    }

    const onMessage = (event) => {
        const data = event.data
        if (data && data.type === 'hsFormCallback' && data.eventName === 'onFormReady') {
            // HubSpot rendert die Felder unmittelbar nach dem Event
            window.setTimeout(() => {
                if (fillHubspotForm(prefill)) {
                    window.removeEventListener('message', onMessage)
                }
            }, 0)
        }
    }
    window.addEventListener('message', onMessage)
}

export default function init() {
    initTeaserForms()
    initHubspotPrefill()
}
